import { ViewIds } from '@ardoq/api-types';
import { ViewExporter } from './types';
import { exportHtmlView } from './exportHtmlView';

const viewExporters: Partial<Record<string, ViewExporter>> = {
  [ViewIds.DEPENDENCY_MAP_2]: exportHtmlView,
  [ViewIds.TIMELINE]: exportHtmlView,
  [ViewIds.COMPONENTTREE]: exportHtmlView,
};
export { viewExporters };
